import React from "react"
import {Drawer, Form, Input, InputNumber, Row, Col, Select, Button, Switch} from "antd"
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {compose} from "recompose";
import { sortBy } from 'lodash';
import * as SelectionActions from "../../reducers/selection_builder";
import {withRouter} from "react-router";

const {Option} = Select;


class CreationGroupDrawer extends React.Component {


    static propTypes = {
        insertGroup: PropTypes.func.isRequired
    };

    onSubmit = (e) => {
        e.preventDefault();
        const {match} = this.props;
        const urlId = match.params.id;

        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                this.props.history.push(`/selection/builder/${urlId}/update/row`);
                this.props.insertGroup(values, urlId);
                this.props.toggleVisibility()
            }
        });
    };



    render() {
        const {visible, toggleVisibility, populate, toEdit, form: {getFieldDecorator}} = this.props;

        console.log("populate", populate)
        console.log("toEdit", toEdit)

        return <Drawer title="Update row item" width={720} placement="right" visible={visible} style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
        }} onClose={toggleVisibility}>
            <Form onSubmit={this.onSubmit}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Education">
                            {getFieldDecorator('education', {
                                rules: [{required: false, message:   'Please select a Education'}],
                                initialValue:toEdit.education,
                            })(
                                <Select
                                    allowClear={true}
                                    placeholder="Education"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {sortBy(populate.education, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Person Type">
                            {getFieldDecorator('persType', {
                                rules: [{required: false, message: 'Please select a Person Type'}],
                                initialValue: toEdit.persType
                            })(
                                <Select allowClear={true}
                                        placeholder="Person Type"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.persType, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '1' ? '' : '(Inactive)'}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Person Super Speciality">
                            {getFieldDecorator('persSuperSpc', {
                                rules: [{required: false, message: 'Please select Person Super Speciality'}],
                                initialValue: toEdit.persSuperSpc
                            })(
                                <Select allowClear={true}
                                        placeholder="Person Super Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.persSuperSpc, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Person Speciality">
                            {getFieldDecorator('persSpc', {
                                rules: [{required: false, message: 'Please select Person Speciality'}],
                                initialValue: toEdit.persSpc
                            })(
                                <Select allowClear={true}
                                        placeholder="Person Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.persSpc, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Site Type">
                            {getFieldDecorator('siteType', {
                                rules: [{required: false, message: 'Please select a Site Type'}],
                                initialValue: toEdit.siteType
                            })(
                                <Select allowClear={true}
                                        placeholder="Site type"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.siteType, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Position">
                            {getFieldDecorator('posistion', {
                                rules: [{required: false, message: 'Please select a Position'}],
                                initialValue: toEdit.position
                            })(
                                <Select allowClear={true}
                                        placeholder="Position"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.posistion, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Working Speciality">
                            {getFieldDecorator('workingSpec', {
                                rules: [{required: false, message: 'Please select a Working Speciality'}],
                                initialValue: toEdit.workingSpecialty
                            })(
                                <Select allowClear={true}
                                        placeholder="Working Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.workingSpec, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Site Speciality">
                            {getFieldDecorator('siteSpeciality', {
                                rules: [{required: false, message: 'Please select a Site Speciality'}],
                                initialValue: toEdit.siteSpeciality
                            })(
                                <Select allowClear={true}
                                        placeholder="Site Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.siteSpec, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item label="Private/Public Sector Type">
                            {getFieldDecorator('sectorType', {
                                rules: [{required: false, message: 'Please select a Sector Type'}],
                                initialValue: toEdit.sectorType
                            })(
                                <Select allowClear={true}
                                        placeholder="Sector Type"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.sectorType, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                   <Col span={6}>
                       <Form.Item label="Postal Range Begin">
                           {getFieldDecorator('siteZipFrom', {
                                rules: [{required: false, message: 'Please specify an postal code range start'}],
                               initialValue: toEdit.siteZipFrom
                           })(
                               <InputNumber placeholder="Range begin">
                               </InputNumber>
                           )}
                       </Form.Item>
                   </Col>
                    <Col span={6}>
                        <Form.Item label="Postal Range End">
                            {getFieldDecorator('siteZipTo', {
                                rules: [{required: false, message: 'Please specify an postal code range end'}],
                                initialValue: toEdit.siteZipTo
                            })(
                                <InputNumber placeholder="Range end">
                                </InputNumber>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Site aPureBase ID">
                            {getFieldDecorator('parentSiteApurebaseId', {
                                rules: [{required: false, message: 'Please specify a site aPureBase ID'}],
                                initialValue: toEdit.parentSiteApurebaseId
                            })(
                                <InputNumber style={{width:'100%'}} placeholder="Site aPureBase ID">
                                </InputNumber>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="ID">
                            {getFieldDecorator('id', {
                                initialValue: toEdit.row_id,
                                rules: [{required: true, message: 'Please enter a ID'}],
                            })(<Input disabled={true} placeholder="ID"/>)}
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Form.Item label="Active">
                            {getFieldDecorator('status', {
                                valuePropName: 'checked',
                                initialValue: toEdit.row_active === '1'
                            })(
                                <Switch />
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Form.Item label="Site Selection">
                            {getFieldDecorator('isSiteSelection', {
                                valuePropName: 'checked',
                                initialValue: toEdit.isSiteSelection === '1'
                            })(
                                <Switch />
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={2}>
                        <Form.Item label="Include all links">
                            {getFieldDecorator('allPersonLinks', {
                                valuePropName: 'checked',
                                initialValue: toEdit.allPersonLinks === '1'
                            })(
                                <Switch />
                            )}
                        </Form.Item>
                    </Col>

                </Row>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button
                        style={{
                            marginRight: 8,
                        }}
                        onClick={toggleVisibility}
                    >
                        Cancel
                    </Button>
                    <Button onClick={this.onSubmit} type="primary">Submit</Button>
                </div>
            </Form>
        </Drawer>
    }

}

const mapStateToProps = state => ({
    overview: state.selection_builder.overview,
    overviewLoader: state.selection_builder.overviewLoader
});

const mapDispatchToProps = dispatch => ({
    insertGroup: bindActionCreators(SelectionActions, dispatch).updateSlectionRow,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(CreationGroupDrawer);



// WEBPACK FOOTER //
// ./src/js/selection/update/SelectionGroupRowUpdateDrawer.js